// Top US wholesaling markets — content tuned for local SEO
// Heavy weighting on Michigan (Detroit metro) per business strategy

export const cities = [
  {
    slug: 'detroit-mi',
    name: 'Detroit',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Detroit, MI',
    metaTitle: 'We Buy Houses Detroit MI | Cash Home Buyers & Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Detroit, Michigan house fast for cash — any condition, any neighborhood. Investors: get exclusive off-market Detroit wholesale deals. No agents, no fees.',
    intro:
      'Detroit is the #1 real estate wholesaling market in America. Whether you own a vacant home in Brightmoor, an inherited property in East English Village, or a tired rental in Hamtramck — we buy houses across Wayne County for cash, in any condition, with no repairs and no fees.',
    sellerCopy:
      'Foreclosure looming? Tax-foreclosed property in the Wayne County auction? Tenant from hell in a Dexter-Linwood duplex? We close fast on Detroit homes — typically 7–21 days — and handle title work, back taxes, and code violations on our end.',
    buyerCopy:
      'Our Detroit buyer list gets first look at SFR fix-and-flips, BRRRR rentals in cash-flowing zip codes (48205, 48227, 48238, 48224), and Section-8 portfolios. Most deals close 30–50% below ARV with assignable contracts.',
    neighborhoods: [
      'Brightmoor', 'East English Village', 'Bagley', 'Boston-Edison', 'North End',
      'Morningside', 'Hamtramck', 'Dexter-Linwood', 'Russell Woods', 'Warrendale',
    ],
    zips: ['48201', '48202', '48204', '48205', '48206', '48207', '48208', '48209', '48210', '48211', '48212', '48213', '48214', '48215', '48217', '48219', '48221', '48223', '48224', '48227', '48228', '48234', '48235', '48238'],
    keywords: 'we buy houses detroit, sell my house fast detroit, cash home buyers detroit michigan, detroit wholesale properties, detroit real estate investors, off market deals detroit, detroit fix and flip, BRRRR detroit, distressed properties detroit, foreclosure help detroit',
    geo: { lat: 42.3314, lon: -83.0458 },
  },
  {
    slug: 'flint-mi',
    name: 'Flint',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Flint, MI',
    metaTitle: 'We Buy Houses Flint MI | Cash for Distressed Properties | DreamHousesUSA',
    metaDescription: 'Sell your Flint, Michigan house fast — vacant, water-damaged, code violations, no problem. Investors: join our Flint wholesale buyer list for high-cashflow deals.',
    intro:
      'Flint is one of the highest-yielding cashflow markets in the Midwest. Properties trade for $25K–$80K with rents that produce 1.5%+ monthly. We move fast on Flint single-families, duplexes, and small multifamily.',
    sellerCopy:
      'Out-of-state owner tired of property management? Inherited a Flint home you never wanted? Facing demolition orders from the Genesee County Land Bank? We close as-is in 14 days.',
    buyerCopy:
      'Flint wholesale deals on our list typically hit 12–18% cash-on-cash returns. Strong rental demand from healthcare workers (Hurley, McLaren) keeps occupancy high.',
    neighborhoods: ['Carriage Town', 'College Cultural', 'Mott Park', 'Civic Park', 'Eastside', 'Westside'],
    zips: ['48503', '48504', '48505', '48506', '48507'],
    keywords: 'we buy houses flint, sell my house fast flint michigan, flint wholesale deals, cash buyers flint mi, flint rental properties, flint distressed homes',
    geo: { lat: 43.0125, lon: -83.6875 },
  },
  {
    slug: 'grand-rapids-mi',
    name: 'Grand Rapids',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Grand Rapids, MI',
    metaTitle: 'We Buy Houses Grand Rapids MI | Fast Cash Offers | DreamHousesUSA',
    metaDescription: 'Sell your Grand Rapids, Michigan home fast for cash. Investors: access off-market wholesale deals in Kent County. No commissions, no repairs, close in days.',
    intro:
      "Grand Rapids has been one of the Midwest's fastest-appreciating markets. We help homeowners in Heritage Hill, Eastown, and Creston exit fast — and connect investors with fix-and-flip opportunities others never see.",
    sellerCopy:
      'Need to relocate fast? Divorce, job transfer, or downsizing? We make a cash offer in 24 hours with no showings, no inspections, no repair credits.',
    buyerCopy:
      'GR buyers get assignable contracts on SFRs in appreciating zips (49503, 49504, 49506, 49507). ARVs $200K–$400K with strong rental demand from MSU and downtown employers.',
    neighborhoods: ['Heritage Hill', 'Eastown', 'Creston', 'Wealthy Heights', 'Garfield Park', 'Alger Heights'],
    zips: ['49503', '49504', '49505', '49506', '49507', '49508', '49509'],
    keywords: 'we buy houses grand rapids, sell my house fast grand rapids michigan, grand rapids wholesale properties, cash home buyers grand rapids',
    geo: { lat: 42.9634, lon: -85.6681 },
  },
  {
    slug: 'lansing-mi',
    name: 'Lansing',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Lansing, MI',
    metaTitle: 'We Buy Houses Lansing MI | Sell Fast for Cash | DreamHousesUSA',
    metaDescription: 'Sell your Lansing, Michigan house fast for cash. Off-market wholesale deals for investors in Ingham County. Close in 7–21 days.',
    intro:
      'Lansing offers strong rent-to-price ratios with the stability of state-government and MSU employment. We buy houses across Ingham, Eaton, and Clinton counties.',
    sellerCopy:
      'Tired landlord? Property near MSU you can no longer manage from out of state? We make a no-obligation cash offer in 24 hours.',
    buyerCopy:
      "Lansing wholesale deals on our list: SFRs $50K–$120K, student rentals near MSU, and small-multifamily near Sparrow Hospital.",
    neighborhoods: ['Old Town', 'REO Town', 'Westside', 'Eastside', 'Walnut', 'Groesbeck'],
    zips: ['48906', '48910', '48911', '48912', '48915', '48933'],
    keywords: 'we buy houses lansing, sell my house fast lansing michigan, lansing wholesale deals, cash buyers lansing mi',
    geo: { lat: 42.7325, lon: -84.5555 },
  },
  {
    slug: 'warren-mi',
    name: 'Warren',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Warren, MI',
    metaTitle: 'We Buy Houses Warren MI | Macomb County Cash Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Warren, MI home fast for cash. Macomb County wholesale buyers — close in days, any condition, no agent fees.',
    intro:
      "Warren is Michigan's third-largest city and a workhorse rental market with strong demand from auto workers and tradespeople. We close fast on Warren and broader Macomb County properties.",
    sellerCopy:
      'Inherited mom and dad’s Warren bungalow? Tired of repairs and Macomb County taxes? We buy as-is, pay in cash, and close on your timeline.',
    buyerCopy:
      'Warren SFRs $90K–$180K with rents producing 0.9–1.1% monthly. Solid blue-collar rental demand.',
    neighborhoods: ['Downtown Warren', 'Warren Village', 'Center Line border', 'Van Dyke corridor'],
    zips: ['48088', '48089', '48091', '48092', '48093'],
    keywords: 'we buy houses warren michigan, sell house fast warren mi, macomb county cash buyers, warren wholesale properties',
    geo: { lat: 42.5145, lon: -83.0147 },
  },
  {
    slug: 'memphis-tn',
    name: 'Memphis',
    state: 'Tennessee',
    stateAbbr: 'TN',
    headline: 'We Buy Houses for Cash in Memphis, TN',
    metaTitle: 'We Buy Houses Memphis TN | Cash Home Buyers & Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Memphis house fast for cash. Investors: join our Memphis wholesale list — turnkey rentals, BRRRR opportunities, and fix-and-flips in Shelby County.',
    intro:
      'Memphis is the cashflow capital of the South. We buy houses across Shelby County and supply our buyer list with the city’s strongest off-market deals.',
    sellerCopy:
      'Out-of-state landlord burned by Memphis property management? Inherited a Frayser or Whitehaven property? We close as-is, in cash, no inspections.',
    buyerCopy:
      'Memphis wholesale deals: SFRs $40K–$95K, post-rehab rentals returning 9–14% cash-on-cash. Section 8 friendly zips: 38109, 38127, 38128.',
    neighborhoods: ['Frayser', 'Whitehaven', 'Raleigh', 'Hickory Hill', 'Berclair', 'Orange Mound'],
    zips: ['38109', '38114', '38115', '38116', '38118', '38122', '38127', '38128'],
    keywords: 'we buy houses memphis, sell my house fast memphis, memphis wholesale deals, memphis turnkey rentals, cash buyers memphis tn',
    geo: { lat: 35.1495, lon: -90.0490 },
  },
  {
    slug: 'cleveland-oh',
    name: 'Cleveland',
    state: 'Ohio',
    stateAbbr: 'OH',
    headline: 'We Buy Houses for Cash in Cleveland, OH',
    metaTitle: 'We Buy Houses Cleveland OH | Cuyahoga County Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Cleveland, Ohio house fast for cash. Investors: access off-market Cuyahoga County wholesale properties with high cashflow returns.',
    intro:
      "Cleveland's Cuyahoga County is one of the strongest BRRRR markets in the country. We buy houses in any condition across the metro and assign fast.",
    sellerCopy:
      'Tax-foreclosed property in the Cuyahoga Land Bank? Inherited a Slavic Village or Old Brooklyn home? We close in 14 days, no banks, no contingencies.',
    buyerCopy:
      'Cleveland deals: SFR rentals $30K–$80K, multi-family in Lakewood and Garfield Heights, and value-add commercial. Cashflow markets: 44102, 44105, 44109.',
    neighborhoods: ['Slavic Village', 'Old Brooklyn', 'Detroit-Shoreway', 'Tremont', 'Glenville', 'Buckeye'],
    zips: ['44102', '44103', '44104', '44105', '44108', '44109', '44110', '44111', '44120'],
    keywords: 'we buy houses cleveland, sell my house fast cleveland ohio, cleveland wholesale properties, cuyahoga county cash buyers, BRRRR cleveland',
    geo: { lat: 41.4993, lon: -81.6944 },
  },
  {
    slug: 'birmingham-al',
    name: 'Birmingham',
    state: 'Alabama',
    stateAbbr: 'AL',
    headline: 'We Buy Houses for Cash in Birmingham, AL',
    metaTitle: 'We Buy Houses Birmingham AL | Jefferson County Wholesale | DreamHousesUSA',
    metaDescription: 'Sell your Birmingham, Alabama house fast for cash. Investors: get exclusive Jefferson County off-market wholesale and BRRRR deals.',
    intro:
      'Birmingham combines low entry prices with appreciating neighborhoods like Avondale and Crestwood. We buy houses across Jefferson County in any condition.',
    sellerCopy:
      'Inherited probate property? Tired landlord in Ensley or Bessemer? We pay cash, no commissions, no repairs.',
    buyerCopy:
      'Birmingham buyer list: turnkey rentals $50K–$110K, BRRRR opportunities in 35208, 35211, 35214, and value-add multi-family.',
    neighborhoods: ['Avondale', 'Crestwood', 'Ensley', 'Woodlawn', 'East Lake', 'Bessemer'],
    zips: ['35206', '35208', '35211', '35214', '35215', '35221', '35224'],
    keywords: 'we buy houses birmingham al, sell my house fast birmingham alabama, birmingham wholesale properties, jefferson county cash buyers',
    geo: { lat: 33.5186, lon: -86.8104 },
  },
  {
    slug: 'indianapolis-in',
    name: 'Indianapolis',
    state: 'Indiana',
    stateAbbr: 'IN',
    headline: 'We Buy Houses for Cash in Indianapolis, IN',
    metaTitle: 'We Buy Houses Indianapolis IN | Marion County Cash Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Indianapolis house fast for cash. Investors: access Marion County off-market wholesale deals and high-yield rental properties.',
    intro:
      'Indianapolis is a top-5 wholesaling market with strong rent-to-price ratios and friendly landlord laws. We buy across Marion County and surrounding metros.',
    sellerCopy:
      'Need to sell a Far Eastside or Mapleton-Fall Creek home fast? We close in 7–21 days, cash, no inspections.',
    buyerCopy:
      'Indy wholesale deals: SFRs $60K–$130K, multi-family near IUPUI, and Section-8 portfolios in 46201, 46218, 46226.',
    neighborhoods: ['Far Eastside', 'Mapleton-Fall Creek', 'Haughville', 'Martindale-Brightwood', 'Near Eastside'],
    zips: ['46201', '46202', '46208', '46218', '46222', '46226'],
    keywords: 'we buy houses indianapolis, sell my house fast indy, indianapolis wholesale properties, marion county cash buyers',
    geo: { lat: 39.7684, lon: -86.1581 },
  },
  {
    slug: 'philadelphia-pa',
    name: 'Philadelphia',
    state: 'Pennsylvania',
    stateAbbr: 'PA',
    headline: 'We Buy Houses for Cash in Philadelphia, PA',
    metaTitle: 'We Buy Houses Philadelphia PA | Philly Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Philadelphia row home fast for cash. Investors: access off-market Philly wholesale deals across Kensington, North Philly, and West Philly.',
    intro:
      "Philadelphia's row-home market is a wholesaler's dream — high inventory of distressed properties with strong investor demand from NYC and DC buyers.",
    sellerCopy:
      'Inherited a Philly row home with L&I violations? Vacant property with squatters? We handle all of it and pay cash.',
    buyerCopy:
      'Philly deals: row homes $50K–$140K in 19121, 19132, 19133, 19134, 19140. Strong fix-and-flip ARVs and emerging rental zones.',
    neighborhoods: ['Kensington', 'Strawberry Mansion', 'Brewerytown', 'Point Breeze', 'North Philadelphia'],
    zips: ['19121', '19132', '19133', '19134', '19140', '19143'],
    keywords: 'we buy houses philadelphia, sell my philly house fast, philadelphia wholesale row homes, philly cash buyers',
    geo: { lat: 39.9526, lon: -75.1652 },
  },
  {
    slug: 'baltimore-md',
    name: 'Baltimore',
    state: 'Maryland',
    stateAbbr: 'MD',
    headline: 'We Buy Houses for Cash in Baltimore, MD',
    metaTitle: 'We Buy Houses Baltimore MD | Charm City Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Baltimore row home fast for cash. Investors: tap our Baltimore wholesale list for off-market rowhouses and value-add multi-family.',
    intro:
      "Baltimore's row-home inventory rivals Philly's, with attractive yields in emerging neighborhoods like Curtis Bay, Pigtown, and Highlandtown.",
    sellerCopy:
      'Tax sale looming? Inherited a vacant rowhouse with code violations? We pay cash, close fast, and clean up everything.',
    buyerCopy:
      'Baltimore deals: shell rehabs $20K–$60K, turnkey rentals $80K–$130K. ARVs in 21223, 21217, 21213 are climbing.',
    neighborhoods: ['Curtis Bay', 'Pigtown', 'Highlandtown', 'Sandtown-Winchester', 'Patterson Park'],
    zips: ['21213', '21215', '21216', '21217', '21223', '21224', '21225'],
    keywords: 'we buy houses baltimore, sell my house fast baltimore md, baltimore wholesale rowhouses, charm city cash buyers',
    geo: { lat: 39.2904, lon: -76.6122 },
  },
  {
    slug: 'st-louis-mo',
    name: 'St. Louis',
    state: 'Missouri',
    stateAbbr: 'MO',
    headline: 'We Buy Houses for Cash in St. Louis, MO',
    metaTitle: 'We Buy Houses St. Louis MO | Cash for Distressed Homes | DreamHousesUSA',
    metaDescription: 'Sell your St. Louis house fast for cash. Investors: off-market wholesale deals across North and South City with strong cashflow yields.',
    intro:
      "St. Louis offers some of the lowest entry prices in the Midwest with surprisingly strong rental demand. We buy across the city and St. Louis County.",
    sellerCopy:
      'Owe back taxes? Vacant property with violations? We buy in any condition, pay cash, close in 14 days.',
    buyerCopy:
      'St. Louis wholesale deals: SFRs $30K–$85K in 63115, 63116, 63118, 63139. Strong yields, friendly landlord laws.',
    neighborhoods: ['Dutchtown', 'Tower Grove', 'Baden', 'Hyde Park', 'College Hill'],
    zips: ['63106', '63107', '63113', '63115', '63116', '63118'],
    keywords: 'we buy houses st louis, sell my house fast st louis mo, st louis wholesale properties, missouri cash buyers',
    geo: { lat: 38.6270, lon: -90.1994 },
  },
  {
    slug: 'kansas-city-mo',
    name: 'Kansas City',
    state: 'Missouri',
    stateAbbr: 'MO',
    headline: 'We Buy Houses for Cash in Kansas City, MO',
    metaTitle: 'We Buy Houses Kansas City MO | KC Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Kansas City house fast for cash. Investors: join our KC buyer list for off-market deals across Jackson and Clay counties.',
    intro:
      "KC blends cashflow with appreciation, especially in Northland and east of Troost. We buy houses in any condition across the metro.",
    sellerCopy:
      'Need to relocate? Inherited Aunt Marge’s KC bungalow? We make a 24-hour cash offer, close in days.',
    buyerCopy:
      'KC wholesale deals: SFRs $60K–$120K, multi-family near downtown, and emerging zip codes 64127, 64128, 64130.',
    neighborhoods: ['Ivanhoe', 'East 23rd Street Corridor', 'Manheim Park', 'Marlborough', 'Blue Hills'],
    zips: ['64109', '64127', '64128', '64130', '64132'],
    keywords: 'we buy houses kansas city, sell my house fast kc, kansas city wholesale properties, kc cash buyers',
    geo: { lat: 39.0997, lon: -94.5786 },
  },
  {
    slug: 'atlanta-ga',
    name: 'Atlanta',
    state: 'Georgia',
    stateAbbr: 'GA',
    headline: 'We Buy Houses for Cash in Atlanta, GA',
    metaTitle: 'We Buy Houses Atlanta GA | Metro Atlanta Wholesale | DreamHousesUSA',
    metaDescription: 'Sell your Atlanta house fast for cash. Investors: off-market wholesale deals in Fulton, DeKalb, and Clayton counties with strong appreciation.',
    intro:
      "Metro Atlanta is one of the country's fastest-growing markets. We buy houses across Fulton, DeKalb, Clayton, and Cobb in any condition.",
    sellerCopy:
      'Need to sell fast? Probate property in South Fulton? We close in 21 days or less, cash, no contingencies.',
    buyerCopy:
      'Atlanta deals: SFR fix-and-flips $100K–$250K, BRRRR rentals in emerging zips (30310, 30314, 30315, 30331), and infill teardowns.',
    neighborhoods: ['East Point', 'College Park', 'Bankhead', 'Pittsburgh', 'Mechanicsville', 'Westview'],
    zips: ['30310', '30311', '30314', '30315', '30331', '30344'],
    keywords: 'we buy houses atlanta, sell my house fast atlanta ga, atlanta wholesale properties, metro atlanta cash buyers',
    geo: { lat: 33.7490, lon: -84.3880 },
  },
  {
    slug: 'jacksonville-fl',
    name: 'Jacksonville',
    state: 'Florida',
    stateAbbr: 'FL',
    headline: 'We Buy Houses for Cash in Jacksonville, FL',
    metaTitle: 'We Buy Houses Jacksonville FL | Duval County Cash Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Jacksonville house fast for cash. Investors: off-market wholesale deals across Duval County with rental demand from JAXPORT and the Navy.',
    intro:
      "Jacksonville offers the lowest entry prices in Florida with strong rental demand from military, port workers, and healthcare. We buy across Duval County.",
    sellerCopy:
      'Tired landlord? Storm-damaged property? We buy as-is, pay cash, and handle all the paperwork.',
    buyerCopy:
      'Jax wholesale deals: SFRs $90K–$170K, multifamily near NAS Jax, and value-add in 32208, 32209, 32254.',
    neighborhoods: ['Northside', 'Westside', 'Murray Hill', 'Springfield', 'Arlington'],
    zips: ['32206', '32208', '32209', '32210', '32254'],
    keywords: 'we buy houses jacksonville, sell my house fast jax fl, jacksonville wholesale properties, duval county cash buyers',
    geo: { lat: 30.3322, lon: -81.6557 },
  },
  {
    slug: 'sterling-heights-mi',
    name: 'Sterling Heights',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Sterling Heights, MI',
    metaTitle: 'We Buy Houses Sterling Heights MI | Macomb County Cash Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Sterling Heights, Michigan home fast for cash. Macomb County wholesale buyers — any condition, close in days, no agent fees.',
    intro:
      "Sterling Heights is Michigan's fourth-largest city and a solid Macomb County rental market with strong demand from auto and tech workers. We buy as-is across Sterling Heights and the surrounding Tri-County area.",
    sellerCopy:
      'Relocating? Downsizing from a 4-bed colonial? Tired of property tax hikes? We make a cash offer in 24 hours and close on your timeline.',
    buyerCopy:
      'Sterling Heights SFRs $180K–$320K. Stable B-class rental neighborhoods, low vacancy, strong appreciation since 2020.',
    neighborhoods: ['Sterlingbrook', 'Plumbrook', 'Riverbend', 'Lakeside', 'Utica border'],
    zips: ['48310', '48312', '48313', '48314'],
    keywords: 'we buy houses sterling heights mi, sell my house fast sterling heights, macomb county cash buyers, sterling heights wholesale',
    geo: { lat: 42.5803, lon: -83.0302 },
  },
  {
    slug: 'dearborn-mi',
    name: 'Dearborn',
    state: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash in Dearborn, MI',
    metaTitle: 'We Buy Houses Dearborn MI | Wayne County Cash Home Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Dearborn, Michigan home fast for cash. We buy houses in any condition in West Dearborn, East Dearborn, and Springwells.',
    intro:
      'Dearborn — Ford’s hometown — offers stable rental demand from auto workers and the largest Arab-American community in the US. We buy across West Dearborn, East Dearborn, and Springwells.',
    sellerCopy:
      'Inherited a Dearborn bungalow? Out-of-state and tired of managing? We close in 14–21 days, cash, any condition.',
    buyerCopy:
      'Dearborn SFRs $120K–$220K, with strong rental demand. Cashflow zips: 48120, 48124, 48126.',
    neighborhoods: ['West Dearborn', 'East Dearborn', 'Springwells', 'Aviation Sub'],
    zips: ['48120', '48124', '48126', '48128'],
    keywords: 'we buy houses dearborn mi, sell my house fast dearborn, dearborn wholesale properties, wayne county cash buyers',
    geo: { lat: 42.3223, lon: -83.1763 },
  },
  {
    slug: 'phoenix-az',
    name: 'Phoenix',
    state: 'Arizona',
    stateAbbr: 'AZ',
    headline: 'We Buy Houses for Cash in Phoenix, AZ',
    metaTitle: 'We Buy Houses Phoenix AZ | Maricopa County Cash Home Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Phoenix house fast for cash. Investors: get off-market Maricopa County wholesale deals — fix-and-flips, BRRRR rentals, and infill opportunities.',
    intro:
      "Phoenix is one of America's fastest-growing metros and a top-3 wholesaling market by deal volume. We buy houses across Maricopa County — Phoenix, Glendale, Mesa, Tempe, Chandler, and Avondale — in any condition.",
    sellerCopy:
      'Inherited a Sun City home? Tired landlord with a Maryvale rental? Pre-foreclosure in West Phoenix? We close in 7–21 days, cash, no inspections or repairs.',
    buyerCopy:
      'Phoenix wholesale deals: SFR fix-and-flips $250K–$450K, BRRRR rentals in emerging zips (85009, 85017, 85033, 85041), and value-add multifamily near ASU and downtown.',
    neighborhoods: ['Maryvale', 'South Mountain', 'Alhambra', 'Sunnyslope', 'Garfield', 'Coronado'],
    zips: ['85003', '85007', '85008', '85009', '85015', '85017', '85019', '85031', '85033', '85035', '85041'],
    keywords: 'we buy houses phoenix, sell my house fast phoenix az, phoenix wholesale properties, maricopa county cash buyers, phoenix fix and flip, phoenix BRRRR rentals',
    geo: { lat: 33.4484, lon: -112.0740 },
  },
  {
    slug: 'tucson-az',
    name: 'Tucson',
    state: 'Arizona',
    stateAbbr: 'AZ',
    headline: 'We Buy Houses for Cash in Tucson, AZ',
    metaTitle: 'We Buy Houses Tucson AZ | Pima County Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Tucson, Arizona house fast for cash. Investors: access Pima County off-market wholesale deals with strong cashflow yields.',
    intro:
      "Tucson offers Arizona's best cashflow with prices 30–40% below Phoenix. Strong rental demand from UA students, Davis-Monthan AFB, and Raytheon. We buy across Pima County in any condition.",
    sellerCopy:
      'Out-of-state landlord done with Tucson property management? Inherited a midtown ranch? We pay cash, close fast, handle the paperwork.',
    buyerCopy:
      'Tucson SFRs $150K–$280K with rents producing 0.8–1.2% monthly. Section-8 friendly zips: 85705, 85706, 85713, 85714.',
    neighborhoods: ['Midtown', 'South Tucson', 'Flowing Wells', 'Sunnyside', 'Menlo Park', 'Barrio Hollywood'],
    zips: ['85705', '85706', '85710', '85711', '85713', '85714', '85746'],
    keywords: 'we buy houses tucson, sell my house fast tucson az, tucson wholesale properties, pima county cash buyers',
    geo: { lat: 32.2226, lon: -110.9747 },
  },
  {
    slug: 'los-angeles-ca',
    name: 'Los Angeles',
    state: 'California',
    stateAbbr: 'CA',
    headline: 'We Buy Houses for Cash in Los Angeles, CA',
    metaTitle: 'We Buy Houses Los Angeles CA | LA County Cash Home Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Los Angeles house fast for cash — probate, divorce, distressed, any condition. Investors: off-market LA wholesale deals with assignable contracts.',
    intro:
      'Los Angeles is a high-equity market where wholesalers thrive on probate, divorce, and tired-landlord situations. We buy across LA County — South LA, East LA, San Fernando Valley, San Gabriel Valley, Long Beach, and Inglewood.',
    sellerCopy:
      'Probate property in South LA? Inherited a Compton duplex? Sandwiched in mortgage with no equity? We close fast, all cash, no contingencies, no agent commissions.',
    buyerCopy:
      'LA wholesale deals: fix-and-flips $400K–$900K in emerging zips (90001, 90003, 90011, 90044, 90059), ADU-conversion opportunities, and small multi-family.',
    neighborhoods: ['South LA', 'Compton', 'Watts', 'Inglewood', 'Boyle Heights', 'Highland Park', 'Van Nuys'],
    zips: ['90001', '90003', '90011', '90037', '90044', '90059', '90061', '90220', '91331', '91342'],
    keywords: 'we buy houses los angeles, sell my house fast la, los angeles wholesale properties, LA county cash buyers, probate property los angeles',
    geo: { lat: 34.0522, lon: -118.2437 },
  },
  {
    slug: 'sacramento-ca',
    name: 'Sacramento',
    state: 'California',
    stateAbbr: 'CA',
    headline: 'We Buy Houses for Cash in Sacramento, CA',
    metaTitle: 'We Buy Houses Sacramento CA | Sac County Cash Home Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Sacramento house fast for cash. Investors: access Sacramento County off-market wholesale deals — fix-and-flips and BRRRR rentals.',
    intro:
      "Sacramento blends California upside with relative affordability. We buy across Sacramento County — Oak Park, Del Paso, Meadowview, North Highlands, and Citrus Heights — in any condition.",
    sellerCopy:
      'Need to relocate? Inherited a Del Paso ranch? Underwater on a Natomas flip? We make a no-obligation cash offer in 24 hours.',
    buyerCopy:
      'Sacramento deals: SFRs $300K–$500K, BRRRR rentals in 95815, 95820, 95823, 95838, and ADU-conversion plays in Oak Park.',
    neighborhoods: ['Oak Park', 'Del Paso Heights', 'Meadowview', 'North Highlands', 'South Sacramento', 'Tahoe Park'],
    zips: ['95815', '95817', '95820', '95822', '95823', '95824', '95838'],
    keywords: 'we buy houses sacramento, sell my house fast sacramento ca, sacramento wholesale properties, sac county cash buyers',
    geo: { lat: 38.5816, lon: -121.4944 },
  },
  {
    slug: 'bakersfield-ca',
    name: 'Bakersfield',
    state: 'California',
    stateAbbr: 'CA',
    headline: 'We Buy Houses for Cash in Bakersfield, CA',
    metaTitle: 'We Buy Houses Bakersfield CA | Kern County Cash Home Buyers | DreamHousesUSA',
    metaDescription: 'Sell your Bakersfield house fast for cash. Investors: California’s best cashflow market — Kern County off-market wholesale deals.',
    intro:
      "Bakersfield is California's #1 cashflow market — prices 60% below LA with rents that produce real returns. We buy across Kern County in any condition.",
    sellerCopy:
      'Out-of-state owner? Oilfield bust property? Inherited a Bakersfield ranch? We close in 14–21 days, all cash, no inspections.',
    buyerCopy:
      'Bakersfield wholesale deals: SFRs $180K–$280K with rents $1,400–$1,800. Section-8 friendly zips: 93304, 93305, 93306, 93307, 93308.',
    neighborhoods: ['East Bakersfield', 'Oildale', 'South Bakersfield', 'Lamont', 'Greenfield', 'Old Town Kern'],
    zips: ['93301', '93304', '93305', '93306', '93307', '93308', '93309'],
    keywords: 'we buy houses bakersfield, sell my house fast bakersfield ca, bakersfield wholesale properties, kern county cash buyers, california cashflow rentals',
    geo: { lat: 35.3733, lon: -119.0187 },
  },
];

export const getCityBySlug = (slug) => cities.find((c) => c.slug === slug);

// Group by state for navigation
export const citiesByState = cities.reduce((acc, c) => {
  acc[c.state] = acc[c.state] || [];
  acc[c.state].push(c);
  return acc;
}, {});
